import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
let template = require('./setup.html');

class SetUpComponent extends ComponentRegistration {

    constructor() {
        super('setup', {
            controller: SetUpController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
            },
            $routeConfig: [
                { path: '/', component: 'landing', name: 'Landing', useAsDefault: true },
                { path: '/content', component: 'contentEditor', name: 'ContentEditor' },
                { path: '/content/:id', component: 'contentEditor', name: 'SelectedTemplateContentEditor' },
                { path: '/fpp-settings', component: 'fppSettings', name: 'FppSettings' },
                { path: '/fpp-settings/:id', component: 'fppSettings', name: 'SelectedFppSettingsPromo' }
            ]
        });
    }
}

interface ISetUpController {
   
}

class SetUpController implements ISetUpController {
    private static $inject: Array<string> = [];

    constructor() {
        console.log('SetUpController loading');

    }

}

let setUpComponent = new SetUpComponent();
export default setUpComponent;
export { setUpComponent as SetUpComponent, ISetUpController, SetUpController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/setup/setup.ts